/** Shared marker for football event binaries and their ladder groups. */
export const CFB_EVENT_SYNTH_MARKER = '|cfb-';

/** Kalshi UFC fight props (#848): the same single-binary event synth as the
 *  football rows (one Kalshi book in both slots, YES/NO wording in the two
 *  name slots), under its own marker so the football live resolver never
 *  claims a fight row. */
export const UFC_FIGHT_PROP_SYNTH_MARKER = '|ufcprop-';

export function cfbEventSynthKey(gameKey: string, cls: string, identity: string): string {
  return `${cfbEventGroupKey(gameKey, cls)}-${identity}`;
}

export function cfbEventGroupKey(gameKey: string, cls: string): string {
  return `${gameKey}${CFB_EVENT_SYNTH_MARKER}${cls}`;
}

/** `<gameKey>|ufcprop-<exact venue ticker>` (a Kalshi KXUFC* prop or a
 *  Polymarket fight prop on the bout's slug stem) — the ticker is the identity the
 *  live resolver re-finds. */
export function ufcFightPropSynthKey(gameKey: string, ticker: string): string {
  return `${gameKey}${UFC_FIGHT_PROP_SYNTH_MARKER}${ticker}`;
}

export function hasUfcFightPropSynthKey(key: string): boolean {
  return key.includes(UFC_FIGHT_PROP_SYNTH_MARKER);
}

/** Every single-binary event synth the order ticket treats alike:
 *  football Game Props and Fight Props (Kalshi, and Polymarket's on the bout's
 *  slug stem). No team toggle, and the YES/NO
 *  captions are the synth's own proposition, never a side winning. */
export function hasCfbEventSynthKey(key: string): boolean {
  return key.includes(CFB_EVENT_SYNTH_MARKER) || hasUfcFightPropSynthKey(key);
}

/** Negate the complete venue proposition, including compound/Neither outcomes.
 * Never infer that NO means the opposing team wins. */
export function cfbEventNoLabel(yesLabel: string): string {
  return yesLabel.trim() ? `Not: ${yesLabel}` : '';
}

export function cfbEventOutcomeLabel(
  row: { awayName?: string; homeName?: string }, side: 'yes' | 'no',
): string {
  if (!row.awayName?.trim() || !row.homeName?.trim() || row.awayName === row.homeName) {
    return '(outcome unavailable)';
  }
  return `(${side === 'yes' ? row.awayName : row.homeName})`;
}
